import { ChipProps } from 'components/Chip/Types'
import { ListProps, useListState } from '@react-stately/list'
import Styles from './ListSelect.module.scss'
import { Check2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { ReactNode } from 'react'
import { ItemProps } from '@react-types/shared'
import { Item } from '@react-stately/collections'

export interface ListSelectProps extends ListProps<ChipProps> {
  limit?: number
}

interface ListItemProps<T> extends ItemProps<T> {
  icon?: ReactNode
}

export const ListItem: <T>(props: ListItemProps<T>) => JSX.Element = Item

export const ListSelect = ({ selectionMode = 'single', limit, ...listProps }: ListSelectProps) => {
  const state = useListState({ ...listProps, selectionMode })

  return (
    <div className={Styles.root}>
      {[...state.collection].map((item) => (
        <div
          className={Styles.listOption}
          key={item.key}
          aria-label={item.textValue}
          onClick={() => {
            if (
              !state.selectionManager.isSelected(item.key) &&
              limit &&
              state.selectionManager.selectedKeys.size === limit
            ) {
              const lastEntry = [...state.selectionManager.selectedKeys].pop()
              lastEntry && state.selectionManager.selectedKeys.delete(lastEntry)
            }

            state.selectionManager.toggleSelection(item.key)
          }}
        >
          {item.props.icon && <div className={Styles.icon}>{item.props.icon}</div>}
          <Text variant="largeList" color="var(--dark-80)">
            {item.textValue}
          </Text>
          {state.selectionManager.isSelected(item.key) && (
            <div className={Styles.isSelectedIcon}>
              <Check2 size={16} color="var(--selected-stroke)" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
